import LoadingModal from '@components/atoms/modals/LoadingModal';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const TellAFriendPage = lazy(() => import('@pages/tellafriend/TellAFriend'));
const RefereePage = lazy(() => import('@pages/tellafriend/RefereePage'));

export const TellAFriendRoutes = (
    <>
        <Route
            path="/tell-a-friend"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'KycVerified',
                        'Pending',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <TellAFriendPage />
                        </Suspense>
                    }
                />
            }
        />
        <Route
            path="/referee"
            element={
                <Suspense fallback={<LoadingModal />}>
                    <RefereePage />
                </Suspense>
            }
        />
    </>
);
